<template>
    <div class="report_export_root">
        <a-spin tip="加载中..." 
            style="width:100%;text-align:center;margin-top:40px;margin-bottom:20px;" 
            :spinning="loading">
            </a-spin>
        <div :style="{'display':loading?'none':'block'}">
            <div class="main_report_index_home">
                <div class="main_report_index_header" style="margin:0;padding:0;">
                    <span style="background: #0072ff;display:block;color:white;font-size:22px;line-height:60px;height:60px;text-align:center">
                        {{ company.name }}检测报告
                    </span>
                    <a-carousel arrow
                    ref="carousel"
                    :afterChange="currentCoverIndex">
                        <el-image fit="cover" 
                            style="width: 100%; height: 70vw"
                            v-for="(cover_url, index) in coverUrlList" 
                            :src="cover_url"
                            :preview-src-list="coverUrlList"
                            :key="index">
                        </el-image>
                    </a-carousel>
                    <div style="width:100%;height:40px;background:#0072ff;" v-if="coverUrlList && coverUrlList.length > 0">
                        <a @click="showDrawer" style="text-align:center;color:white;width:100%;display:block;line-height:40px;font-size:16px;">
                            点击查看图片列表 >>>
                        </a>
                    </div>
                    <a-drawer
                        title="选择图片"
                        placement="right"
                        :closable="false"
                        width="75%"
                        :visible="drawerVisible"
                        :bodyStyle="{'background':'#eee'}"
                        :drawerStyle="{'background':'#eee'}"
                        @close="hideDrawer"
                        >
                        <el-image fit="cover"  
                        v-for="(cover_url, index) in coverUrlList" 
                        :src="cover_url" 
                        :key="index" 
                        @click="setCurrentCoverUrl(index)" 
                        :style="{'border':getCurrentCoverUrlIndexValidate(index)?'2px solid #aaaaee':'2px solid #ddd', 'background':'white','margin':getCurrentCoverUrlIndexValidate(index)?'10px':'10px'}" 
                        style="margin:10px;border-radius:5px;padding:10px;width:40%;"
                        >
                        </el-image>
                    </a-drawer>
                </div>
                <div>
                    <h1 style="margin-left:10px;margin-right:10px;font-size:20px;font-weight:bold;margin-top:10px;">
                        {{ auto.model }}
                    </h1>
                    <ul style="overflow:hidden;margin:0;padding:0;margin-left:10px;margin-right:10px;">
                        <li style="width:100%;height:40px;">
                            <span style="float:left;width:100px;height:40px;line-height:40px;font-size:18px;font-weight:bold;">
                                VIN码
                            </span>
                            <span style="float:left;line-height:40px;height:40px;font-size:16px;">
                                {{ auto.vin_no }}
                            </span>
                        </li>
                        <li style="width:100%;height:40px;">
                            <span style="float:left;width:100px;font-size:18px;font-weight:bold;line-height:40px;height:40px;">
                                车牌号
                            </span>
                            <span style="float:left;line-height:40px;height:40px;font-size:16px;">
                                {{ auto.license_plate }}
                            </span>
                        </li>
                        <li style="width:100%;height:40px;">
                            <span style="float:left;width:100px;font-size:18px;font-weight:bold;line-height:40px;height:40px;">
                                检测师
                            </span>
                            <span style="float:left;line-height:40px;height:40px;font-size:16px;">
                                {{ inspector.name }}
                            </span>
                        </li>
                        <li style="width:100%;height:40px;">
                            <span style="float:left;width:100px;font-size:18px;font-weight:bold;line-height:40px;height:40px;">
                                检测时间
                            </span>
                            <span style="float:left;line-height:40px;height:40px;font-size:16px;">
                                {{ order.detected_at | formatDateZH }}
                            </span>
                        </li>
                    </ul>
                    <div style="position: absolute; top: 65%; left: 50%; transform: translate(calc(-50% + 50px), -50%);">
                        <el-image fit="cover" :src="urls.static.company_searl" style="width:30vw;height:30vw;margin-top:7vw;text-align:right;">
                        </el-image>
                    </div>
                </div>
                
                <div class="main_report_index_content" style="background:white;height:100%;margin-top:20px;">
                    <div class="base_info" style="height:60px;width:100%;">
                        <ul style="margin:0;padding:0;">
                            <li style="margin:0;padding:0;width:10px;height:30px;float:left;margin-left:10px;">
                                <div style="background:#155CF0;width:8px;height:16px;margin-top:22px;margin-right:0px;float:left;"></div>
                            </li>
                            <li style="margin:0;padding:0;float:left;">
                                <span style="display:block;width:200px;height:24px;line-height:24px;margin-top:19px;text-align:left;font-weight:bold;margin-left:6px;font-size:20px;color:#155CF0;">
                                    检测概要
                                </span>
                            </li>
                        </ul>
                    </div>
                    <ul style="overflow:hidden;margin:0;padding:0;">
                        <div style="margin:0;padding:0;height:60px;" @click="mainMenuSelect(index)" v-for="(group_object, index) in export_groups" :key="index">
                            <ul style="overflow:hidden;margin:0;padding:0;margin-left:5px;margin-right:5px;">
                                <li style="margin:0;padding:0;float:right;margin-right:10px;">
                                    <el-image fit="cover"  style="float:right;width:20px;height:20px;margin-top:20px;" v-if="group_object.warning_count>0||group_object.success_count>0" :src="group_object.warning_count>0?require('@/assets/warning.png'):require('@/assets/ok.png')">
                                    </el-image>
                                    <span v-if="group_object.warning_count>0" style="float:right;display:block;line-height:60px;color:black;margin-right:5px;font-size:16px;">
                                        有{{ group_object.warning_count }}处
                                    </span>
                                    <span v-if="group_object.warning_count==0 && group_object.success_count>0" style="float:right;display:block;line-height:60px;color:black;margin-right:5px;font-size:16px;">
                                        正常
                                    </span>
                                    <span v-if="group_object.warning_count==0&&group_object.success_count==0" style="float:right;display:block;line-height:60px;color:black;margin-right:5px;font-size:16px;">
                                        未检测
                                    </span>
                                </li>
                                <li style="margin:0;padding:0;float:left;margin-left:10px;">
                                    <span style="display:block;line-height:60px;color:#999;font-size:18px;font-weight:bold;">
                                        {{ group_object.group_name }}
                                    </span>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">
                            </div>
                        </div>
                        <li style="margin:0;padding:0;margin-top:20px;">
                            <ul style="overflow:hidden;margin:0;padding:0;">
                                <li style="margin:0;padding:0;margin-left:15px;margin-right:15px;">
                                    <p style="display:block;word-break:break-all;word-wrap:break-word;font-size:16px;" v-if="order.hasOwnProperty('test_result')">
                                        <span style="font-weight:bold;">
                                            检测结果及保养建议:
                                        </span>
                                        &nbsp;&nbsp;&nbsp; {{ order.maintenance_recommendations }}
                                    </p>
                                </li>
                            </ul>
                            <div style="margin-left:10px;margin-right:10px;background:#ccc;height:1px;">
                            </div>
                        </li>
                        <b-button block v-b-toggle="'accordion-more'" ref="accordion_button" style="background:#0072ff;" variant="info" @click="clickMore">{{ moreText }}</b-button>
                    </ul>
                </div>
                <b-collapse id="accordion-more" class="mb-1" style="background:white;margin-top:20px;background:#eee;">
                    <b-card id="accordion-999" no-body class="mb-2">
                        <ul v-b-toggle="'accordion-999'" style="background:white;color:black;margin: 0;padding: 0;height:60px;">
                            <li style="margin:0;padding:0;float:left;">
                                <span style="display:block;background:#155CF0;width:10px;height:20px;line-height:16px;margin-top:20px;margin-left:10px;">
                                </span>
                            </li>
                            <li style="float:left;">
                                <span style="display:block;height:100%;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;color:#155CF0;">
                                    基本信息
                                </span>
                            </li>
                            <li style="float:right;">
                                <el-image fit="cover"  :src="base_collapse_visible?require('@/assets/down.png'):require('@/assets/forward.png')" style="width:20px;height:20px;margin-top:20px;margin-right:10px;">
                                    
                                </el-image>
                            </li>
                        </ul>
                        <div style="width:100%;height:1px;background:#ccc;">
                        </div>
                        <b-collapse :visible="base_collapse_visible" v-model="base_collapse_visible" :id="'accordion-999'" role="tabpanel">
                            <b-card-body>
                                <ul style="overflow:hidden;margin:0;padding:0;">
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    注册地
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ auto_address }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    初登日期
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ auto.first_boarding_date }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    表显里程
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ auto.meter_mileage }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    国/进/合
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ menu.vehicle_source[auto.vehicle_source] }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    排量
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ auto.displacement }} {{ auto.displacement_unit }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    变速箱
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ menu.gearbox_type[auto.gearbox_type] }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    车身颜色
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span 
                                                    style="width:40px;height:60px;margin-top:10px;line-height:60px;border:1px solid #eee;border-radius:8px;font-size:16px;"
                                                    >
                                                    {{ auto.vehicle_color }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    车辆用途
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ menu.vehicle_use[auto.vehicle_use] }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    使用性质
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ menu.nature_of_use[auto.nature_of_use] }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    发动机号
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ auto.engine_no }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="height:60px;">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;">
                                            <li style="float:left;height:100%;">
                                                <span style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    车险到期日期
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;">
                                                <span style="float:left;line-height:60px;font-size:16px;">
                                                    {{ auto.annual_inspection_expiration }}
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                </ul>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card 
                    :id="'accordion-'+String(idx)" 
                    no-body 
                    class="mb-2" 
                    v-for="(group_object, idx) in export_groups" 
                    :key="idx">
                        <ul 
                        v-b-toggle="'accordion-' + group_object?group_object.group_object_id:String(idx)"
                        style="background:white;color:black;margin: 0;padding: 0;height:60px;">
                            <li style="margin:0;padding:0;float:left;">
                                <span style="display:block;background:#155CF0;width:10px;height:20px;line-height:16px;margin-top:20px;margin-left:10px;">
                                </span>
                            </li>
                            <li style="float:left;">
                                <span style="display:block;height:100%;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;color:#155CF0;">
                                    {{ group_object.group_name }}
                                </span>
                            </li>
                            <li style="float:right;" class="when-closed">
                                <el-image fit="cover"  ref="collapse_arrow" :id="group_object.group_object_group_id" :src="require('@/assets/forward.png')" style="width:20px;height:20px;margin-top:20px;margin-right:10px;">
                                </el-image>
                            </li>
                            <li style="float:right;" class="when-open">
                                <el-image fit="cover"  ref="collapse_arrow" :id="group_object.group_object_group_id" :src="require('@/assets/down.png')" style="width:20px;height:20px;margin-top:20px;margin-right:10px;">
                                </el-image>
                            </li>
                        </ul>
                        <div style="width:100%;height:1px;background:#ccc;">
                        </div>
                        <b-collapse 
                        v-model="collapse_visible_map[group_object.group_object_group_id]" 
                        :id="'accordion-' + group_object?group_object.group_object_id:String(idx)" 
                        role="tabpanel" 
                        class="mb-2"
                        :key="idx">
                            <b-card-body>
                                <ul style="overflow:hidden;margin:0;padding:0;">
                                    <li v-for="(group_item, group_item_index) in group_object.items" :key="group_item_index" :style="{'height':((!group_item.images || group_item.images.length == 0) && group_item.success_count + group_item.warning_count==0)?'0px':calcImageListHeight(group_item.images)}">
                                        <ul style="overflow:hidden;margin:0;padding:0;height:100%;width:100%;"  v-if="group_item.success_count + group_item.warning_count > 0 || (group_item.images && group_item.images.length > 0)">
                                            <li style="float:left;height:100%;">
                                                <span v-if="group_item.show_report_index" style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    {{ group_item.report_index }}. {{ group_item.group_item_name }}
                                                </span>
                                                <span v-else style="width:100%;height:60px;line-height:60px;margin-left:10px;font-size:18px;font-weight:bold;">
                                                    {{ group_item.group_item_name }}
                                                </span>
                                                <ul style="overflow:hidden;margin:0;padding:0;display:block;" v-if="group_item.images && group_item.images.length > 0">
                                                    <li 
                                                        style="float:left;"
                                                        v-for="(image_url, image_index) in group_item.images" :key="image_index">
                                                            <el-image fit="cover"  
                                                                @click="handlePreview($event)"
                                                                style="margin-top:5px;"
                                                                :style="{'margin-left':(image_index % 3==0)?'10px':'5px', 'width':String(image_size)+'px', 'height':String(image_size)+'px'}" 
                                                                :src="image_url">
                                                            </el-image>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li style="float:right;height:100%;overflow:hidden;margin-right:5px;" v-for="(warning_name, warning_index) in group_item.warning_name_list" :key="warning_index">
                                                <el-image fit="cover" style="float:left;width:20px;height:20px;margin-top:20px;margin-right:2px;" :src="require('@/assets/warning.png')">
                                                </el-image>
                                                <span style="float:left;line-height:60px;font-size:16px;" v-if="group_item.show_report_error_name && group_item.report_error_name">
                                                    {{ group_item.report_error_name }}
                                                </span>
                                                <span style="float:left;line-height:60px;font-size:16px;" v-else>
                                                    {{ warning_name }}
                                                </span>
                                            </li>
                                            <li style="float:right;height:100%;" v-if="(group_item.success_count + group_item.warning_count > 0) && (!group_item.warning_name_list || group_item.warning_name_list.length==0)">
                                                <el-image fit="cover" style="float:left;width:20px;height:20px;margin-top:20px;margin-right:10px;" :src="require('@/assets/ok.png')">
                                                </el-image>
                                                <span style="float:left;line-height:60px;font-size:16px;" v-if="group_item.show_report_ok_name && group_item.report_ok_name">
                                                    {{ group_item.report_ok_name }}
                                                </span>
                                                <span style="float:left;line-height:60px;font-size:16px;" v-else>
                                                    正常
                                                </span>
                                            </li>
                                        </ul>
                                        <div style="width:100%;height:1px;background:#ccc;">
                                        </div>
                                    </li>
                                    <li style="margin-top:40px;">
                                        <p style="margin-left:10px;margin-right:10px;font-size:18px;" v-if="group_object.test_result">
                                            <span style="font-weight:bold;">检测结论:</span> &nbsp;&nbsp;&nbsp;{{ group_object.test_result }}
                                        </p>
                                    </li>
                                </ul>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-collapse>
                <div v-if="order.menu_mode=='BASE'" style="background:white;margin-left:10px;margin-right:10px;border-radius:0px 0px 10px 10px;margin-top:50px;">
                    <span style="display:block;height:60px;line-height:60px;padding-left:10px;padding-right:10px;font-size:18px;font-weight:bold;">
                        检测说明
                    </span>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        1、本报告中的所有检测项目结果仅供参考，仅用于车况说明使用，不附带任何承诺和保障。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        2、本检测报告中的“表显里程”仅是检测人员根据所检测车辆仪表上显示的公里数进行填写的，仅供参考
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        3、本检测报告对事故车、泡水车、火烧车检测认定标准如下：
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        （1)<span style="font-weight:bold;">事故车：</span>结构件有损伤，则判定为事故车；覆盖件、加强件有损伤，不判定为事故车。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        （2)<span style="font-weight:bold;">泡水车：</span>车辆车身浸泡在1/3以上（即座位坐垫之上），各种电器设施、电子元件（包括电脑）有维修或更换，部件有泥沙、生锈的痕迹，同时发动机、变速箱有泡水维修痕迹，影响到车辆机械及电气系统的安全使用。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        （3)<span style="font-weight:bold;">火烧车：</span>车身经火焚烧超过0.5平方米，经修复仍存在安全隐患的车辆。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        4、为了保障您的购车权益，请在购买该车辆时委托福州车质宝检测服务有限公司授权的车况检测机构进行的承保检测报告，承保检测报告承诺的三大项目：事故车、泡水车、火烧车，100天内检测失误保价退车，!（超长的保障时间和超性价比的检测费用，助您安心的购买车辆并保障您的合法权益！)
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        5、官方客服热线：<span style="font-weight:bold;">{{ company.office_line_number }}</span>
                    </p>
                </div>
                <div v-if="order.menu_mode=='COMPREHENSIVE'" style="background:white;margin-left:10px;margin-right:10px;border-radius:0px 0px 10px 10px;margin-top:50px;">
                    <span style="display:block;height:60px;line-height:60px;padding-left:10px;padding-right:10px;font-size:18px;font-weight:bold;">
                        检测说明
                    </span>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;font-weight:bold;text-decoration:underline;">
                        1、本报告中仅针对"结构件检测"，"泡水检测"，"火烧检测"做承诺项检测100天，其它检测项目结果仅供参考。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        2、本检测报告中的"表显里程"仅是检测人员根据所检测车辆仪表上显示的公里数进行填写的，仅供参考。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        3、本检测报告中的“车辆基本信息”仅是检测人员根据所检测车辆权属证书等资料进行填写的，如有不一致，以车辆实际权属证书等资料信息为准。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        4、本检测报告对事故车、泡水车、火烧车检测认定标准如下：
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        （1)<span style="font-weight:bold;">事故车：</span>结构件有损伤，则判定为事故车；覆盖件、加强件有损伤，不判定为事故车。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        （2)<span style="font-weight:bold;">泡水车：</span>车辆车身浸泡在1/3以上（即座位坐垫之上），各种电器设施、电子元件（包括电脑）有维修或更换，部件有泥沙、生锈的痕迹，同时发动机、变速箱有泡水维修痕迹，影响到车辆机械及电气系统的安全使用。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        （3)<span style="font-weight:bold;">火烧车：</span>车身经火焚烧超过0.5平方米，经修复仍存在安全隐患的车辆。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        5、官方客服热线：<span style="font-weight:bold;">{{ company.office_line_number }}</span>
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;font-weight:bold;text-decoration:underline;">
                        6、本检测报告"退车保障金"是指：本《车辆检测报告》中载明的退车保障评估金额，除此之外检测方不承担其它任何费用（如：维修费、误工费、贷款利息等）。原价退车保障是指自检测之日起100天内，这期间车辆使用过程中未发生事故，如有发生事故，则是在退车保障金基础上进行相应折价后进行退车保障或经济赔偿。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        7、检测失误（检测有误），检测报告中明确列明的结构件项目、泡水车、火烧车，检测后客户发现有结构件损坏、车辆有泡水、车辆有火烧且在检测前就已存在，而检测报告中没有说明。认定为检测失误（检测有误）。发动机变速箱不属于结构件，有检查但不做承诺保障。
                    </p>
                    <p style="font-size:14px;padding:0px 10px 0px 10px;margin-bottom:10px;">
                        8、检测失误，应自本《车辆检测报告》出具当日起100日内向检测方（客服电话：15606911446,13788891512,18695600029)提出并提交检测失误举证资料。经核实，若检测失误争议属实，双方签订《退车协议》完成车辆过户及退车款结算与车辆交接手续。逾期超出100天未提出的视为放弃权利主张，检测方不再承担保价退车责任。
                    </p>
                </div>
            </div>
        </div>
        <div style="width:100%;height:60px;" v-if="order.detected">
            <a-button type="Primary" :href="report.pdf_url" style="text-align:center;background: #0072ff;color:white;margin:0 auto;padding:0;width:100px;display:block;">
                下载车况报告
            </a-button>
        </div>
        <div style="width:100%;height:70px;margin-top:50px;">
            <span style="line-height:70px;text-align:center;display:block;margin:0 auto;">
                {{ company.copyright_no }} 版权所有
            </span>
            <a style="text-align: center;width:100%;line-height: 20px;height:20px;display: block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
        </div>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <el-image fit="cover"  alt="preview_image" style="width: 100%" :src="previewImage">
            </el-image>
        </a-modal>
        <div
        :style="{'display':(visible)?'block':'none'}"
        style="background:transparent;position:fixed;right:10px;width:40px;height:100%;z-index: 999;top:10px;"
            >
            <ul style="overflow:hidden;margin:0;padding:0;width:100%;height:100%;background:transparent;">
                <li style="margin:0;padding:0;width:100%;margin-top:20px;">
                    <span @click="closeMenu" style="border:1px solid #155CF0;text-align:center;display:block;width:40px;height:40px;background:#155CF0;color:white;line-height:40px;margin:0 auto;border-radius:50%;font-size:12px;">
                        {{ closeMenuName }}
                    </span>
                </li>
                <li :style="{'display':(menu_visible)?'block':'none'}" style="margin:0;padding:0;width:100%;margin-top:10px;">
                    <span @click="menuSelect(999)" :id="'menu-'+String(999)" :style="{'background':(menu_select==999)?'#FFFFFF55':'#155CF055', 'color':(menu_select==999)?'#333':'#FFFFFFAA', 'border':(menu_select==999)?'1px solid #333':'1px solid #155CF055'}" style="text-align:center;display:block;width:40px;height:40px;color:white;line-height:40px;margin:0 auto;border-radius:50%;font-size:12px;">
                        基本
                    </span>
                </li>
                <li :style="{'display':(menu_visible)?'block':'none'}" style="margin:0;padding:0;width:100%;margin-top:10px;" v-for="(group_object, index) in export_order.export_groups" :key="index">
                    <span @click="menuSelect(index)" :id="'menu-'+String(index)" :style="{'background':(menu_select==index)?'#FFFFFF55':'#155CF055', 'color':(menu_select==index)?'#333':'#FFFFFFAA', 'border':(menu_select==index)?'1px solid #333':'1px solid #155CF055'}" style="text-align:center;display:block;width:40px;height:40px;color:white;line-height:40px;margin:0 auto;border-radius:50%;font-size:12px;">
                        {{ group_object.group_short_label }}
                    </span>
                </li>
                <li :style="{'display':(menu_visible)?'block':'none'}" style="margin:0;padding:0;width:100%;margin-top:10px;">
                    <span @click="scrollToTop" style="border:1px solid #333;text-align:center;display:block;width:40px;background:#FFFFFF55;height:40px;color:#333;line-height:40px;margin:0 auto;border-radius:50%;font-size:12px;">
                        Top
                    </span>
                </li>
            </ul>
        </div>
    </div>
    
</template>

<script>
import request from '../../api/request'
import urls from '../../api/urls'
import order_model from '../../model/order'
import menu_model from '../../model/menu'
import global_define from '../../library/global/define'
import company_model from '../../model/company'
import watermark from 'watermark-dom'
import wx from 'weixin-js-sdk'

export default {
    name: 'ReportExport',
    head: {
        title: "预览检测单",
        meta:[
            { name: 'description', content: '预览检测单'}
        ]
    },
    data: function() {
        return {
            moreText: "查看检测明细",
            visible: false,
            drawerVisible: false, 
            order_id: "",
            order: order_model,
            menu: menu_model,
            global_define: global_define,
            urls: urls,
            group_objects: {},
            export_order: {},
            group_object_result: {
            },
            data_dict: {
            },
            image_map: {
            },
            image_size: 100,
            previewVisible: false,
            previewImage: "",
            albumPreviewVisible: false,
            currentCoverUrl: "",
            coverUrlList:[],
            test_result_map: {
            },
            total_warning_count_map: {
            },
            menu_visible: false,
            closeMenuName: "收起",
            menu_select: 1000,
            activeKey: 999,
            collapse_visible_map: {
            },
            base_collapse_visible: true,
            company: company_model,
            loading: false,
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            auto: {},
            customer: {},
            inspector: {},
            export_groups: [],
            report: {},
            auto_address: "",
        }
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        sortGroupObjects(a, b){
            return a.group.report_index-b.group.report_index;
        },
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },

        fetchAuto() {
            this.loading = true
            var detial_resp = request.order.auto_detail(this.order.auto_id, false)
            detial_resp.then((response) => {
                this.loading = false
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.auto = response.data.data
                        this.auto_address = this.auto.register_region.address
                        // 获取车辆信息后更新分享内容
                        this.updatePageMeta()
                        this.setWeChatShare()
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        fetchCustomer() {
            this.loading = true
            var detial_resp = request.order.customer_detail(this.order.customer_id, false)
            detial_resp.then((response) => {
                this.loading = false
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.customer = response.data.data
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        fetchInspector() {
            this.loading = true
            var detial_resp = request.order.inspector_detail(this.order.inspector_id, false)
            detial_resp.then((response) => {
                this.loading = false
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.inspector = response.data.data
                        // 获取检测师信息后更新分享内容
                        this.updatePageMeta()
                        this.setWeChatShare()
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        fetchReport() {
            var detial_resp = request.order.report_detail(this.order.report_id, false)
            detial_resp.then((response) => {
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.report = response.data.data
                    }
                }
            })
        },
        currentCoverIndex(current) {
            if (current < this.coverUrlList.length) {
                this.currentCoverUrl = this.coverUrlList[current]    
            }
        },
        hideDrawer() {
            this.drawerVisible = false
        },
        showDrawer() {
            this.drawerVisible = true
        },
        setCurrentCoverUrl(index) {
            if (index < this.coverUrlList.length) {
                this.currentCoverUrl = this.coverUrlList[index]
                if (this.$refs.carousel) {
                    this.$refs.carousel.goTo(index)
                }
                // 切换封面图片后更新分享内容
                this.setWeChatShare()
            }
            this.drawerVisible = false
        },
        getCurrentCoverUrlIndexValidate(index) {
            
            var cover_url = (this.coverUrlList.length > index)?this.coverUrlList[index]:""
            if (cover_url == this.currentCoverUrl) {
                return true
            }
            return false
        },
        collapse_visible_click(index) {
            
            if (this.order && this.export_groups && index < this.export_groups.length) {
                var group_object = this.export_groups[index]
                this.collapse_visible_map[group_object.group_object_group_id] = !this.collapse_visible_map[group_object.group_object_group_id]
                console.log(this.collapse_visible_map[group_object.group_object_group_id])
                this.$forceUpdate()
            }
        },
        handleScroll() {
            if (this.menu_visible == true) {
                try {
                    var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                    var element_999 = document.querySelector("#accordion-"+String(999))
                    if (element_999) {
                        var offsetTop_999 = element_999.offsetTop
                        if (offsetTop_999 <= scrollTop+100) {
                            this.menu_select=999
                        }
                        else {
                            this.menu_select = 1000
                        }
                    }
                    
                    var idx = -1
                    for (var group_object of this.export_groups) {
                        var index = this.export_groups.indexOf(group_object)
                        var element = document.querySelector("#accordion-"+String(index))
                        if (element) {
                            var offsetTop = element.offsetTop
                            if (offsetTop <= scrollTop+100) {
                                idx=index
                            }
                        }
                    }
                    if (idx >= 0) {
                        this.menu_select = idx
                    }
                }
                finally {
                    console.log()
                }
            }
        },
        mainMenuSelect(index) {
            let visible = this.visible
            if (this.visible == false) {
                this.$refs.accordion_button.click()
            }
            this.menu_select = index
            this.activeKey = index
            if (index == 999) {
                this.base_collapse_visible = true
            }
            else {
                var group_object = this.export_groups[index]
                this.collapse_visible_map[group_object.group_object_group_id] = true
            }
            if (visible == false) {
                setTimeout(() => {
                    window.scrollTo(0, document.querySelector("#accordion-"+String(index)).offsetTop)
                }, 1000)
            }
            else {
                window.scrollTo(0, document.querySelector("#accordion-"+String(index)).offsetTop)
            }
        },
        menuSelect(index) {
            if (this.visible == false) {
                this.visible = true
            }
            this.menu_select = index
            this.activeKey = index
            if (index == 999) {
                this.base_collapse_visible = true
            }
            else {
                var group_object = this.export_groups[index]
                this.collapse_visible_map[group_object.group_object_group_id] = true
            }
            window.scrollTo(0, document.querySelector("#accordion-"+String(index)).offsetTop)
        },
        closeMenu() {
            this.menu_visible = !this.menu_visible
            if (this.menu_visible) {
                this.closeMenuName = "收起"
            }
            else {
                this.closeMenuName = "打开"    
            }
        },
        scrollToTop() {
            window.scrollTo(0,0);
            this.menu_select = 1000;
        },
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(event) {
            this.previewImage = event.target.currentSrc;
            this.previewVisible = true;
        },
        albumPreviewHandleCancel() {
            this.albumPreviewVisible = false;
        },
        clickCover(index) {
            console.log(index)
            if (this.order && this.order.auto && this.auto.covers && index < this.auto.covers.length) {
                var cover = this.auto.covers[index]
                if (cover.image_url) {
                    this.currentCoverUrl = cover.image_url
                    this.albumPreviewVisible = true
                }
            }
            console.log(this.currentCoverUrl)
        },
        load() {
            this.initial_wexin_share()
            if (this._isMobile()) {
                try {
                    watermark.remove()
                }
                catch (err) {
                    console.log()
                }
                this.fetch_company()
                this.order_id = this.$route.query.order_id
                window.addEventListener('scroll', this.handleScroll, true);
                var width = this.windowWidth - 20 - 10*2 - 1.25 * 16 * 2 - 2*10 - 2*5
                this.image_size = width / 3.0
                this.fetchOrder()
                this.fetchExportOrderDetail()
            }
            else {
                this.$router.push({
                    name: 'ReportReport',
                    query: {
                        order_id:this.order_id,
                    }
                });
            }
        },
        filterImageItems(item) {
            return item.images.length == 0
        },
        calcImageListHeight(image_list) {
            
            var height = "60px"
            var total_height = 60
            if (image_list && image_list.length > 0) {
                var image_height = this.image_size + 20
                var line_count = (image_list.length % 3 != 0) ? parseInt(image_list.length/3)+1 : parseInt(image_list.length/3)
                var total_image_height = line_count * image_height
                total_height = total_image_height + 20
            }
            if (total_height > 60) {
                total_height = 40 + total_height
            }
            
            height = String(total_height) + 'px'
            return height
        },
        fetchExportOrderDetail() {
            this.loading = true
            var order_detial_resp = request.order.export_order_detail(this.order_id)
            order_detial_resp.then((response) => {
                this.loading = false
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.export_order = response.data.data
                        this.export_groups = this.export_order.export_groups
                        this.generateGroupObjectResult()
                        this.coverUrlList = this.export_order.covers
                        if (this.coverUrlList && this.coverUrlList.length > 0) {
                            this.currentCoverUrl = this.coverUrlList[0]
                            // 获取封面图片后更新分享内容
                            this.setWeChatShare()
                        }
                        try {
                            this.$refs.carousel.goTo(0)    
                        }
                        catch(error) {
                            console.log(error)
                        }
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            }).then((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        fetchOrder() {
            this.loading = true
            var order_detial_resp = request.order.detail(this.order_id)
            order_detial_resp.then((response) => {
                this.loading = false
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.order = response.data.data
                        this.fetchReport()
                        this.fetchAuto()
                        this.fetchCustomer()
                        this.fetchInspector()
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            }).then((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        generateGroupObjectResult() {
            for (var group_object of this.export_groups) {

                if (group_object.group_object_group_id) {
                    this.group_object_result[group_object.group_object_group_id] = group_object
                    this.collapse_visible_map[group_object.group_object_group_id] = true
                }
            }
            this.$forceUpdate()
        },
        clickMore() {
            this.visible = !this.visible
            if (this.visible == true) {
                this.moreText = "隐藏检测明细"
            }
            else {
                this.moreText = "显示检测明细"
                this.menu_select = 1000
            }

            this.menu_visible = true
            if (this.menu_visible) {
                this.closeMenuName = "收起"
            }
            else {
                this.closeMenuName = "打开"    
            }
        },
        
        initial_wexin_share() {
            let js_sdk_params_resp = request.wechat.js_sdk_config(window.location.href)
            js_sdk_params_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        let js_sdk_params = response.data.data
                        console.log("js_sdk_params", js_sdk_params)
                        wx.ready(function() {
                            window.initWeChatConfig(
                                js_sdk_params.appId,
                                js_sdk_params.timestamp,
                                js_sdk_params.nonceStr,
                                js_sdk_params.signature
                            );
                            this.updatePageMeta()
                            this.setWeChatShare()
                        })
                        
                    }
                }
            })
        },
        // 微信分享相关方法
        updatePageMeta() {
            // 动态更新页面标题
            if (this.auto && this.auto.model) {
                document.title = `${this.auto.model}-${this.auto.license_plate || ''} - 车质宝检测报告`
            }
            
            // 更新meta标签
            this.updateMetaTag('og:title', `${this.auto.model || '车辆'}-${this.auto.license_plate || ''} - 车质宝检测报告`)
            this.updateMetaTag('og:description', `${this.auto.model || '车辆'}-${this.auto.license_plate || ''}`)
            this.updateMetaTag('og:url', window.location.href)
            this.updateMetaTag('twitter:title', `${this.auto.model || '车辆'}-${this.auto.license_plate || ''} - 车质宝检测报告`)
            this.updateMetaTag('twitter:description', `${this.auto.license_plate || ''}`)
        },
        updateMetaTag(property, content) {
            let meta = document.querySelector(`meta[property="${property}"]`)
            if (!meta) {
                meta = document.createElement('meta')
                meta.setAttribute('property', property)
                document.head.appendChild(meta)
            }
            meta.setAttribute('content', content)
        },
        setWeChatShare() {
            const shareTitle = `${this.auto.model || '车辆'} - ${this.auto.license_plate || ''} - 车质宝检测报告`
            const shareDesc = `${this.auto.license_plate || ''}`
            const shareLink = window.location.href
            const shareImgUrl = this.currentCoverUrl
            
            wx.ready(() => {
                // 分享给朋友
                wx.updateAppMessageShareData({
                    title: shareTitle,
                    desc: shareDesc,
                    link: shareLink,
                    imgUrl: shareImgUrl,
                    success: function () {
                        console.log('分享给朋友设置成功')
                    }
                })
                
                // 分享到朋友圈
                wx.updateTimelineShareData({
                    title: shareTitle,
                    link: shareLink,
                    imgUrl: shareImgUrl,
                    success: function () {
                        console.log('分享到朋友圈设置成功')
                    }
                })
            })
        },
    },
    created() {
        this.load()
    },
    components: {
    }
}
</script>

<style>

.ant-drawer-content {
    background: transparent;
    background-color: transparent;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

</style>
